const gridLines = (canvas, fabric) => {
    var canvasWidth  = canvas.getWidth();
    var canvasHeight = canvas.getHeight();
    
    let scalex = canvasWidth / 3;
    let scaley = canvasHeight / 2;

    var left = 4;
    var top = 4;

    for(var i=0; i<3; i++) {
        var rectangleTop = new fabric.Rect({
            left: left,
            top: top,
            width: scalex-10,
            height: scaley-10,
            fill: '',
            stroke: 'black',
            strokeWidth: 2,
            selectable: false,
        });

        canvas.add(rectangleTop);

        var rectangleBottom = new fabric.Rect({
            left: left,
            top: scaley,
            width: scalex-10,
            height: scaley-10,
            fill: '',
            stroke: 'black',
            strokeWidth: 2,
            selectable: false,
        });

        canvas.sendToBack(rectangleBottom);
        canvas.add(rectangleBottom);

        left += scalex;
    }
    
    canvas.requestRenderAll();
    


    /* var grid = [];
    for (var y = 0; y <= canvasHeight; y += scaley - 1) {
        grid.push("M");
        grid.push("0");
        grid.push(y);
        grid.push("H");
        grid.push(canvasWidth);
    }
    for (var x = 0; x <= canvasWidth; x += scalex - 1) {
        grid.push("M");
        grid.push(x);
        grid.push("0");
        grid.push("V");
        grid.push(canvasHeight);
    }
    var gridPath = new fabric.Path(grid.join(" "), {
        // lockMovementX: false,
        // lockMovementY: false,
        // clickable: false,
        top  : 0,
        left : 0,
        strokeWidth: 3,
        stroke: '#ccc',
        hoverCursor: 'default',
        // hasBorders: false,
        // hasControls: false,
        // hasRotatingPoint: false,
        selectable: false,
        // evented: false
    })

    canvas.sendToBack(gridPath);
    canvas.add(gridPath);
    canvas.requestRenderAll();
    // canvas.renderAll(); */
}

export default gridLines;